let intervalRef = null;

export function startDemoSimulator(dispatch) {
  if (intervalRef || typeof dispatch !== "function") return;

  // Initial discovery snapshot
  const nodes = [
    {
      id: "demo-ewl",
      name: "Demo EWL-810",
      type: "PDM",
      typeLabel: "I/O",
      address: "0x50",
      category: "Power",
      status: "OK",
      hw: "v1.0",
      firmware: "v1.0.0",
      lastSeen: "just now",
      subtype: "EWL-810",
      autoCreatePrompted: false,
    },
  ];

  const devices = [
    {
      id: "demo-ewl-ch1",
      nodeId: "demo-ewl",
      channelIndex: 1,
      type: "pdm-channel",
      name: "Demo Light",
      dimmable: true,
      mode: "Dimming",
      showOnDashboard: true,
      softFuseEnabled: false,
      control: { on: true, dim: 60 },
      metrics: { current: "2.0", currentUnit: "A" },
    },
  ];

  dispatch({ type: "load-discovery", payload: { nodes, devices } });

  // Telemetry ticker (e.g., oscillate current)
  intervalRef = setInterval(() => {
    const current = (1.5 + Math.random() * 1.0).toFixed(1);
    dispatch({
      type: "telemetry/update",
      deviceId: "demo-ewl-ch1",
      payload: { current, updatedAt: Date.now() },
    });
  }, 2000);
}

export function stopDemoSimulator() {
  if (intervalRef) {
    clearInterval(intervalRef);
    intervalRef = null;
  }
}
